(function () {
  function woodstoryUnhideJudgeme() {
    document.querySelectorAll('.woodstory-jdgm-reviews style.jdgm-temp-hiding-style').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.woodstory-jdgm-reviews .jdgm-rev-widg, .woodstory-jdgm-reviews .jdgm-widget').forEach(function (el) {
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', woodstoryUnhideJudgeme);
  else woodstoryUnhideJudgeme();
  window.addEventListener('load', woodstoryUnhideJudgeme);
  setTimeout(woodstoryUnhideJudgeme, 200);
  setTimeout(woodstoryUnhideJudgeme, 1000);
  setTimeout(woodstoryUnhideJudgeme, 2500);
})();
